/**
 * Main actions that determine which page/component to display
 */
export enum MainAction {
    COMMON_ACTIONS = 'common_actions',
    ADMIN_TRANSLATIONS = 'admin_translations',
    ORDER_ELIGIBILITY = 'order_eligibility',
    STORE_FEATURES = 'store_features',
    REFUND_CALCULATOR = 'refund_calculator',
    CREATE_PLATFORM_STORE = 'create_platform_store',
    PROFILES = 'profiles',
    EMAIL_VALIDATION = 'email_validation',
    CREATE_ADMINISTRATORS = 'create_administrators',
}

/**
 * Supported platforms for store creation
 */
export enum PlatformType {
    GLOBAL_E = 'global_e',
    // Add more platforms here in the future
}

/**
 * Common actions for fetch operations and basic troubleshooting tasks
 */
export enum CommonAction {
    FETCH_CUSTOMER = 'fetch_customer',
    FETCH_DISCOUNT_CODE = 'fetch_discount_code',
    FETCH_ORDER = 'fetch_order',
    FETCH_ORDER_BY_ID = 'fetch_order_by_id',
    FETCH_ORDER_BY_RMA_ID = 'fetch_order_by_rma_id',
    FETCH_DRAFT_ORDER_BY_ID = 'fetch_draft_order_by_id',
    FETCH_DRAFT_ORDER = 'fetch_draft_order',
    FETCH_PRODUCT = 'fetch_product',
    FETCH_VARIANTS = 'fetch_variants',
    FETCH_FULFILLMENT_BY_ID = 'fetch_fulfillment_by_id',
    FETCH_RMA = 'fetch_rma',
    FETCH_ORDER_ELIGIBILITY_LEGACY = 'fetch_order_eligibility_legacy',
    FETCH_SUPERADMIN_ACTIONS = 'fetch_superadmin_actions',
    BULK_RMA_CANCELLED = 'bulk_rma_cancelled',
    BULK_RMA_DONE = 'bulk_rma_done',
    BULK_RMA_APPROVED = 'bulk_rma_approved',
    BULK_RMA_AUTO_REFUND = 'bulk_rma_auto_refund',
    TRANSFER_REJECTED_RMA_TO_CANCELED = 'transfer_rejected_rma_to_canceled',
    CREATE_SECONDARY_PORTAL = 'create_secondary_portal',
    COPY_STORE_SETTINGS = 'copy_store_settings',
    CLEAR_TRANSLATIONS_CACHE = 'clear_translations_cache',
    CHANGE_STORE_OWNER = 'change_store_owner',
    REMOVE_USER_FROM_STORE = 'remove_user_from_store',
    TROUBLESHOOTING_UPLOAD_CSV = 'troubleshooting_upload_csv',
}

/**
 * Metadata for main actions
 */
export interface IMainActionMetadata {
    id: MainAction;
    label: string;
    isComplex: boolean; // If true, replaces entire content area
    isSysAdminOnly?: boolean; // If true, only shows to sys admin
}

/**
 * Metadata for common actions
 */
export interface ICommonActionMetadata {
    id: CommonAction;
    label: string;
    requiresInput?: boolean;
    inputLabel?: string; // Label for the input field (e.g., "Order Name", "RMA ID")
    requiresStoresSelect?: boolean; // For copy store settings
    requiresAdditionalInput?: boolean; // For actions like BULK_RMA_DONE
    additionalInputLabel?: string;
    requiresToggle?: boolean; // For actions that need a true/false toggle
    toggleLabel?: string; // Label for the toggle
    isSysAdminOnly?: boolean; // If true, only shows to sys admin
    requiresFileUpload?: boolean; // Multipart CSV (or other) upload instead of text input
}
